import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { tap,map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {

    public basePath: any = environment.apiendpoint;
    public settingPath: any = environment.SettingsApiendpoint;
    public user: any;
    public all_permissions: any;
    public permissions: any;
    private _isLoggedIn$ = new BehaviorSubject<boolean>(false);

    constructor(private http: HttpClient, private router: Router, private toastr: ToastrService
    ) {
        this._isLoggedIn$.next(!!this.token);
        if (this.token) {
            this.user = this.geuser ? this.geuser : '';
            this.permissions = this.getpermissions ? this.getpermissions : '';
            this.all_permissions = this.getall_permissions ? this.getall_permissions : '';
        }
    }

    adminlogin(data: any) {
        const url = `${this.basePath}/signin`
        return this.http.post(url, data).pipe(
            tap((response: any) => {
                if(response.success){
                    // console.log(response); return;

                    this._isLoggedIn$.next(true);
                    this.user = response.data.user;

                    localStorage.setItem('token', JSON.stringify(response.token));
                    localStorage.setItem('user', JSON.stringify(response.data.user));
                    // localStorage.setItem('dateFormat','yyyy-dd-MM');
                    localStorage.setItem('dateFormat',response.data.setting.date_format.replace('mm', 'MM'));
                    localStorage.setItem('currency',response.data.setting.currency);
                    localStorage.setItem('country_id', response.data.setting.country_id);
                    localStorage.setItem('show_sales', response.data.setting.show_sales);
                    localStorage.setItem('show_runner', response.data.setting.show_runner);
                    localStorage.setItem('show_finance_report', response.data.setting.show_finance_report);
                    localStorage.setItem('show_fc_hc_feature', response.data.setting.show_fc_hc_feature);
                    localStorage.setItem('show_distance_report', response.data.setting.show_distance_report);
                    localStorage.setItem('allow_repeat_order', response.data.setting.allow_repeat_order);
                    localStorage.setItem('show_order_hospital', response.data.setting.show_order_hospital);
                    localStorage.setItem('show_order_provider', response.data.setting.show_order_provider);
                    localStorage.setItem('show_order_facility', response.data.setting.show_order_facility);
                    localStorage.setItem('is_device_service', response.data.setting.is_device_service);
                    localStorage.setItem('msp_lab_requisition_show', response.data.setting.msp_lab_requisition_show);
                    // localStorage.setItem('msp_lab_requisition_show', 'false');
                    
                    const thisper = [];
                    response.data.permissions.map(val => {
                        thisper.push(val.name);
                    });

                    const thisallper = [];
                    response.data.all_permissions.map(val => {
                        thisallper.push(val.name);
                    });

                    localStorage.setItem('permissions', JSON.stringify(thisper));
                    localStorage.setItem('all_permissions', JSON.stringify(thisallper));

                    this.permissions = thisper;

                    this.getMapConfig().subscribe((config: any) => {
                        // console.log('Map config fetched successfully', JSON.stringify(config.data));

                        localStorage.setItem('mapConfig', JSON.stringify(config.data));
                    }, (err) => {
                        console.error('Failed to fetch map config', err);
                    });
                    // this.all_permissions = thisallper;
                }

            })
        );
    }
    newRegister(data: any) {
        const url = `${this.basePath}/new-register`
        return this.http.post(url, data).pipe(
            tap((response: any) => {
                if(response.success){
                    // this._isLoggedIn$.next(true);

                    // this.all_permissions = thisallper;
                }

            })
        );
    }

    get token() {
        return JSON.parse(localStorage.getItem('token'));
    }

    get getpermissions() {
        return JSON.parse(localStorage.getItem('permissions'));
    }


    get getall_permissions() {
        return JSON.parse(localStorage.getItem('all_permissions'));
    }


    get geuser() {
        return JSON.parse(localStorage.getItem('user'));
    }

    logout() {
        this.router.navigate(['/login'])
        return localStorage.clear();
    }
    getMapConfig() {
        return this.http.get(`${this.settingPath}/map-creds`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem('token') || '""')}`
            }
        });
    }
}
